import React from 'react';
import { DocumentCard } from './DocumentCard';
import { DocumentPdfModal } from './DocumentPdfModal';
import {
  getDocumentId,
  getDocumentState,
  handleDocumentAction,
  getDocumentModalUrl,
  getFreeDocumentModalUrl,
} from './documentsUtils';

function isFreeDocument(doc) {
  return !doc?.hasPassword || doc.freeDocument || doc.freeSample;
}

const SECTION_TITLE_STYLE = {
  fontSize: '0.875rem',
  fontWeight: '600',
  textTransform: 'uppercase',
  color: '#666',
  margin: '0 0 0.5rem 0',
  letterSpacing: '0.05em',
};

/**
 * List of documents (cheat sheets or worksheets) with view/preview/buy actions.
 */
export function DocumentsPanel({
  documents,
  type,
  isSubscribed,
  isLoggedIn,
  subscriptionPrice,
  miniCart,
  ownedProducts,
  onAddToCart,
  onSubscribe,
}) {
  const [selectedDoc, setSelectedDoc] = React.useState(null);
  const [useFullDocument, setUseFullDocument] = React.useState(false);
  const [modalUrlOverride, setModalUrlOverride] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);

  if (!documents || documents.length === 0) return null;

  const openDocumentInModal = (doc, showFullDoc) => {
    // Free samples: open in modal using topics download URL (no login required)
    if (isFreeDocument(doc)) {
      const freeUrl = getFreeDocumentModalUrl(doc);
      if (freeUrl) {
        setSelectedDoc(doc);
        setUseFullDocument(true);
        setModalUrlOverride(freeUrl);
        setModalOpen(true);
      }
      return;
    }
    const url = getDocumentModalUrl(doc, showFullDoc);
    if (url) {
      setSelectedDoc(doc);
      setUseFullDocument(showFullDoc);
      setModalUrlOverride(null);
      setModalOpen(true);
    }
  };

  const handleAddToCartWithDoc = (doc) => {
    onAddToCart(getDocumentId(doc));
  };

  const sectionTitle =
    type === 'cheatSheet' ? 'Cheat Sheets' : 'Worksheets';

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h4 style={SECTION_TITLE_STYLE}>{sectionTitle}</h4>

        {documents.map((doc, index) => {
          const state = getDocumentState(doc, {
            ownedProducts,
            miniCart,
            isSubscribed,
          });

          return (
            <DocumentCard
              key={index}
              doc={doc}
              index={index}
              type={type}
              state={state}
              isLoggedIn={isLoggedIn}
              subscriptionPrice={subscriptionPrice}
              onView={(d) =>
                handleDocumentAction(d, {
                  ownedProducts,
                  miniCart,
                  isSubscribed,
                  openDocumentInModal,
                  onAddToCart,
                })
              }
              onPreview={(d) => openDocumentInModal(d, false)}
              onAddToCart={handleAddToCartWithDoc}
              onSubscribe={onSubscribe}
            />
          );
        })}
      </div>

      <DocumentPdfModal
        isOpen={modalOpen}
        doc={selectedDoc}
        useFullDocument={useFullDocument}
        urlOverride={modalUrlOverride}
        onClose={() => {
          setModalOpen(false);
          setSelectedDoc(null);
          setUseFullDocument(false);
          setModalUrlOverride(null);
        }}
      />
    </>
  );
}
